import { useCallback } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  ComponentEmptyButton,
  ComponentStartCover,
} from '../shared/component-parts';
import { EditProps } from './interactive.constants';
import { useContainerDimensions } from '../shared/component-height/component-dimensions.hooks';
import { ComponentAbsoluteWrapper } from '../shared/component-height/component-dimensions.style';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import {
  getClosestImageUrl,
  ImageDisplayQuality,
} from 'approot/shared/images/imgix-responsive';

const InteractiveEdit = (props: EditProps) => {
  const { type, sectionId, properties, id, stimulusResourceProperties } = props;

  const { openDrawer, activeComponent } = useActivityBuilderContext();

  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const { style, setContainerElement, elementDimensions } =
    useContainerDimensions({
      aspectRatio: 16 / 9,
    });

  const handleHeightUpdate = useCallback(
    (width: number, height: number) => {
      const dimensionData = {
        ...properties.dimensionData,
        width,
        height: Math.floor(height),
      };
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData,
            },
          },
        },
        properties: {
          ...properties,
          dimensionData,
        },
        typename: 'ActivitiesInteractiveComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return stimulusResourceProperties?.link ? (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === props.id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleHeightUpdate}
    >
      <ComponentAbsoluteWrapper ref={setContainerElement}>
        <ComponentStartCover
          type={type}
          buttonLabel="Start"
          resourceName={props.stimulusResourceProperties?.resourceName || ''}
          backgroundImage={
            stimulusResourceProperties?.xlCoverImageUrls?.length
              ? getClosestImageUrl({
                  imageUrls: stimulusResourceProperties.xlCoverImageUrls,
                  containerSize: elementDimensions?.width
                    ? Math.max(
                        elementDimensions.width,
                        elementDimensions.height
                      )
                    : window.innerWidth,
                  quality: ImageDisplayQuality.High,
                })
              : stimulusResourceProperties?.coverImage?.original
          }
          style={style}
          data-selector="btn-start"
        />
      </ComponentAbsoluteWrapper>
    </ComponentDimensions>
  ) : (
    <ComponentEmptyButton
      iconId="interactive"
      buttonText="Add Interactive"
      onClick={() => openDrawer({ componentId: props.id })}
    />
  );
};

export default InteractiveEdit;
